import {
  InspectorControls,
  store as blockEditorStore,
} from "@wordpress/block-editor";
import {
  PanelBody,
  RangeControl,
  __experimentalUnitControl as UnitControl,
  ToggleControl,
} from "@wordpress/components";
import { __ } from "@wordpress/i18n";
import { useDispatch, useSelect } from "@wordpress/data";
import { useEffect } from "@wordpress/element";
import metadata from "../../block.json";
import { changeTestimonialsNumber } from "../../../TestimonialCard/utils";
import NavigationControls from "./NavigationControls";
import PaginationControls from "./PaginationControls";
import ColorsControls from "./ColorsControls";
import CarouselSettings from "./CarouselSettings";

export default function AllInspectorSettings(props) {
  const { attributes, setAttributes, clientId } = props;
  const { replaceInnerBlocks } = useDispatch(blockEditorStore);

  const { deviceType } = useSelect((select) => {
    const { __experimentalGetPreviewDeviceType } = select("core/edit-post");

    return {
      deviceType: __experimentalGetPreviewDeviceType(),
    };
  }, []);

  const previewDevice = useSelect((select) =>
    (
      (
        select("core/edit-post") ?? select("core/edit-site")
      )?.__experimentalGetPreviewDeviceType() ?? ""
    ).toLowerCase()
  );

  const handleChangeCount = (value) => {
    setAttributes({
      testimonialsCount: value,
    });
    changeTestimonialsNumber({
      rootId: clientId,
      number: value,
      replaceInnerBlocks,
    });
  };
  const handleChangeSlidesPerView = (value) => {
    setAttributes({
      slides: {
        ...attributes.slides,
        [previewDevice]: value,
      },
    });
  };
  const handleChangeCardsSpacing = (value) => {
    setAttributes({
      itemsSpacing: value,
    });
  };

  const handleChangeTestimonialsHasSlider = (value) => {
    setAttributes({
      hasSlider: value,
    });
  };

  useEffect(() => {
    if (!attributes.hasSlider) {
      return;
    }
    const iframe =
      window.jQuery(".edit-site-visual-editor__editor-canvas").length > 0
        ? window.jQuery(".edit-site-visual-editor__editor-canvas")[0]
        : window.jQuery('iframe[name="editor-canvas"]').length > 0
        ? window.jQuery('iframe[name="editor-canvas"]')[0]
        : null;
    const targetWindow = iframe ? iframe.contentWindow : window;
    targetWindow.dispatchEvent(
      new CustomEvent("brandyRefreshTestimonials", {
        detail: {
          block: clientId,
        },
      })
    );
  }, [
    attributes.slides,
    attributes.testimonialsCount,
    attributes.pagination,
    attributes.itemsSpacing,
    attributes.scrollbar,
    attributes.hasSlider,
  ]);

  const slides =
    attributes.slides[previewDevice] ??
    metadata.attributes.slides.default[previewDevice];
  return (
    <>
      <InspectorControls>
        <PanelBody title={__("Settings", "brandy-blocks")}>
          <RangeControl
            __nextHasNoMarginBottom
            label="Testimonials count"
            value={
              attributes.testimonialsCount ??
              metadata.attributes.testimonialsCount.default
            }
            onChange={handleChangeCount}
            min={1}
            max={20}
          />
          <RangeControl
            __nextHasNoMarginBottom
            label="Slides per page"
            value={slides}
            onChange={handleChangeSlidesPerView}
            min={1}
            max={6}
          />
          <UnitControl
            label={__("Cards spacing")}
            onChange={handleChangeCardsSpacing}
            value={attributes.itemsSpacing ?? "30px"}
          />
          <ToggleControl
            __nextHasNoMarginBottom
            label={__("Has slider?")}
            checked={attributes.hasSlider ?? true}
            onChange={handleChangeTestimonialsHasSlider}
          />
          {attributes.hasSlider && (
            <>
              <NavigationControls {...props} />
              <PaginationControls {...props} />
              <ToggleControl
                __nextHasNoMarginBottom
                label="Has scrollbar?"
                checked={attributes.scrollbar?.enabled ?? false}
                onChange={(v) => {
                  setAttributes({
                    scrollbar: {
                      ...(attributes.scrollbar ?? {}),
                      enabled: v,
                    },
                  });
                }}
              />
            </>
          )}
        </PanelBody>
        {attributes.hasSlider && <CarouselSettings {...props} />}
      </InspectorControls>
      {((attributes.hasSlider && (attributes.navigation.enabled ?? true)) ||
        attributes.scrollbar?.enabled ||
        attributes.pagination?.enabled) && (
        <InspectorControls group="styles">
          <ColorsControls {...props} />
        </InspectorControls>
      )}
    </>
  );
}
